
import {
    GET_SKILLS_REQUEST,
    GET_SKILLS_SUCCESS,
    GET_SKILLS_FAIL
  } from "../constants/AuthConstant";

import axios from "axios";

export const CandidateSkillAction = (id) => {
    return function (dispatch) {
      dispatch({
        type: GET_SKILLS_REQUEST,
        payload: true,
      });
     
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/get_candidate_skills_list?id=${id}`,
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      };
      axios(OPTION)
        .then((res) => {
            console.log(res.data,"hello")
          dispatch(loadAllDetailsPre(res.data));
        })
        .catch((error) => {
          dispatch({
            type: GET_SKILLS_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });
        });
    };
  };
  export const loadAllDetailsPre = (data) => {
    return {
      type: GET_SKILLS_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };